import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import { Card, Row, Col, DatePicker, Button, Alert } from 'antd';
import UploadButton from './UploadButton';
import { MinusCircleOutlined, PlusOutlined, FileSearchOutlined, InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import './UploadSkillsFile.less';

const UploadSkillsFile = (props) => {
  const formik = useFormikContext();
  const [certifications, setCertifications] = useState([]);

  const maxSize = props.maxSize !== undefined ? props.maxSize : 3;

  const addCertification = () => {
    const newCert = {
      file: null,
      error: null,
      rawFile: null,
      tgl_terbit: '',
      tgl_expired: '',
    };
    const updated = [...certifications, newCert];
    setCertifications(updated);
    formik.setFieldValue('skills_file', updated);
  };

  const removeCertification = (index) => {
    const updated = certifications.filter((_, i) => i !== index);
    setCertifications(updated);
    formik.setFieldValue('skills_file', updated);
  };

  const handleFileChange = (index, files, error, rawFile) => {
    const updated = [...certifications];
    updated[index] = {
      ...updated[index],
      file: files,
      error: error || null,
      rawFile: rawFile || (error ? files : null),
    };
    setCertifications(updated);
    formik.setFieldValue('skills_file', updated);
  };

  const handleTerbitChange = (index, value) => {
    const updated = [...certifications];
    updated[index] = { ...updated[index], tgl_terbit: value ? value.format('YYYY-MM-DD') : '' };
    setCertifications(updated);
    formik.setFieldValue('skills_file', updated);
  };

  const handleExpiredChange = (index, value) => {
    const updated = [...certifications];
    updated[index] = { ...updated[index], tgl_expired: value ? value.format('YYYY-MM-DD') : '' };
    setCertifications(updated);
    formik.setFieldValue('skills_file', updated);
  };

  React.useEffect(() => {
    if (formik.values.skills_file && Array.isArray(formik.values.skills_file)) {
      setCertifications(formik.values.skills_file);
    }
  }, []);

  return (
    <div className="upload-skills-file">
      <Row align="middle" justify="space-between" className="gx-mb-3">
        <Col>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#262626' }}>
            Upload Bukti Sertifikasi Kompetensi
          </h3>
          <Alert
            type="info"
            showIcon
            icon={<InfoCircleOutlined />}
            message={
              <span>
                <strong>Petunjuk:</strong> Isi tanggal <strong>salah satu sertifikat</strong> yang terbaru / masih berlaku
              </span>
            }
            className="cert-info-banner"
          />
        </Col>
        <Col>
          <Button
            type="dashed"
            onClick={addCertification}
            className="add-cert-btn"
            icon={<PlusOutlined className="add-icon" />}
          >
            Tambah Sertifikasi
          </Button>
        </Col>
      </Row>

      {certifications.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">
            <FileSearchOutlined />
          </div>
          <div className="empty-text">Belum ada sertifikasi yang ditambahkan</div>
        </div>
      )}

      {certifications.map((cert, index) => (
        <Card key={index} className="cert-card gx-mb-3">
          <div className="cert-card-header">
            <div className="cert-number">
              <span className="number-badge">{index + 1}</span>
              <span className="cert-title">Sertifikat #{index + 1}</span>
            </div>
            {certifications.length > 1 && (
              <Button
                type="text"
                danger
                icon={<MinusCircleOutlined />}
                onClick={() => removeCertification(index)}
                className="remove-btn"
              >
                Hapus
              </Button>
            )}
          </div>

          <div className="cert-card-body">
            <Row gutter={[16, 16]}>
              <Col lg={10} md={24} xs={24}>
                <div className="field-wrapper">
                  <span className="field-label">File Sertifikat</span>
                  {cert.error ? (
                    <div style={{ marginBottom: '8px', color: '#ff4d4f' }}>
                      File ditolak: <strong>{cert.rawFile?.name || 'File'}</strong> ({cert.error})
                    </div>
                  ) : cert.file && typeof cert.file === 'object' && cert.file.name ? (
                    <div style={{ marginBottom: '8px', color: '#52c41a' }}>
                      File terpilih: <strong>{cert.file.name}</strong>
                    </div>
                  ) : cert.file_url ? (
                    <div style={{ marginBottom: '8px' }}>
                      <a href={cert.file_url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
                        Lihat File Terunggah
                      </a>
                    </div>
                  ) : null}
                  <UploadButton
                    maxSize={maxSize}
                    onDone={(files, error, rawFile) => handleFileChange(index, files, error, rawFile)}
                  />
                  <div className="gx-text-gray gx-mt-1" style={{ fontSize: 12 }}>
                    Maksimal {maxSize}MB (JPG/PNG/PDF)
                  </div>
                </div>
              </Col>
              <Col lg={7} md={12} xs={24}>
                <div className="field-wrapper">
                  <span className="field-label">Tanggal Terbit</span>
                  <DatePicker
                    value={cert.tgl_terbit ? moment(cert.tgl_terbit) : null}
                    onChange={(value) => handleTerbitChange(index, value)}
                    placeholder="Pilih tanggal terbit"
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                  />
                </div>
              </Col>
              <Col lg={7} md={12} xs={24}>
                <div className="field-wrapper">
                  <span className="field-label">Tanggal Expired</span>
                  <DatePicker
                    value={cert.tgl_expired ? moment(cert.tgl_expired) : null}
                    onChange={(value) => handleExpiredChange(index, value)}
                    placeholder="Pilih tanggal expired"
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Card>
      ))}
    </div>
  );
}

export default UploadSkillsFile;